import React, { useEffect, useState } from "react";
import "./Hero.css";
import logo from "../assets/download.png";

const Hero = () => {
  const [showNavbar, setShowNavbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setShowNavbar(true);
      } else {
        setShowNavbar(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
     
      {/* HERO SECTION */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Reliable <br /> IT Solutions & Quality</h1>

            <p>
              At InfraMart Solutions LLC, Our IT services are designed to support and enhance your business operations through reliable, secure, and scalable technology solutions from network setup and to cloud computing, software support.
            </p>

            <div className="hero-buttons">
              <a href="/services" className="btn-primary-alt">Learn More</a>
              <a href="/contact" className="btn-primary-alt">Get A Quote</a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
